import {
  Plugin,
} from 'ckeditor5';
import FieldEditing from 'views/EMR/components/ckeditor-plugins/Field/editing';

export default class Field extends Plugin {
  static get requires() {
    return [FieldEditing] as const;
  }

  public static get pluginName() {
    return 'Field' as const;
  }
}
